const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditPolygon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.648,
    height: 11.554,
    fill: "none",
    viewBox: "0 0 11.648 11.554",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.7795 0 0 3.7795 -2963.9 -35.128)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 784.66,
    y: 9.7488,
    width: 2.1379,
    height: 2.1379,
    style: {
      fill: "none",
      paintOrder: "stroke markers fill",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 100,
      strokeWidth: 0.39688,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.66,
    cy: 9.7488,
    r: 0.4544,
    style: {
      fillRule: "evenodd",
      fill: "#000",
      paintOrder: "stroke markers fill",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.83,
    cy: 9.7488,
    r: 0.4544,
    style: {
      fillRule: "evenodd",
      fill: "#000",
      paintOrder: "stroke markers fill",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.83,
    cy: 11.897,
    r: 0.4544,
    style: {
      fillRule: "evenodd",
      fill: "#000",
      paintOrder: "stroke markers fill",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.66,
    cy: 11.846,
    r: 0.4544,
    style: {
      fillRule: "evenodd",
      fill: "#000",
      paintOrder: "stroke markers fill",
      stopColor: "#000000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditPolygon);
export default __webpack_public_path__ + "static/media/icon_edit_polygon.200b3d014a75796ce947ff96074729ea.svg";
export { ForwardRef as ReactComponent };